module.exports = __webpack_public_path__ + "static/Picture3-e5f046866cf76aa04c22ddcba86420ac.jpg";